import throttle from 'lodash/throttle'

const $services = $('.our-service-item')
const $servicesSidebarList = $('.our-service-sidebar ul')

const fn = {
  init: () => {
    fn.handleScroll()
    $(window).on('scroll', throttle(fn.handleScroll, 250))
  },

  handleScroll: () => {
    const viewportCenter = window.innerHeight / 2
    let $closest = null
    let closestTop = 9999

    $services.each((_, el) => {
      const rect = el.getBoundingClientRect()

      if (rect.top < closestTop && rect.top > 0) {
        $closest = $(el)
        closestTop = rect.top
      }
    })


    if ($closest) {
      const closestIndex = $closest.index()

      $servicesSidebarList.find('.is-active').removeClass('is-active')
      $servicesSidebarList.find(`li:eq(${closestIndex})`).addClass('is-active')
    }
  }
}

export default {
  can: () => document.body.classList.contains('pagetype-ourservicepage'),
  run: fn.init
}
